export default __webpack_public_path__ + "static/media/about-us-ownership.15bd461a.jpg";